import React from 'react'
import { ChevronDown } from 'react-feather'
import css from './SortSelect.module.css'

type Props<T extends string> = {
  options: { value: T; label: string }[]
  value: T
  onChange: (value: T) => void
}

/**
 * "Sort by Viewed ⌄" as plain gray text. A native select underneath, so the
 * menu, keyboard and screen readers work as everywhere else
 */
const SortSelect = <T extends string>({
  options,
  value,
  onChange,
}: Props<T>) => (
  <label className={css['sort']}>
    Sort by
    <span className={css['control']}>
      <select
        className={css['select']}
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown size={14} className={css['chevron']} aria-hidden />
    </span>
  </label>
)

export default SortSelect
